export default __webpack_public_path__ + "static/media/crane-icon.97bca168.svg";